import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Location } from 'avn/interfaces/homepage';
import { ApiService } from 'avn/services/api.service';
import { Constants } from 'avn/services/constants';
import { StoreService } from 'avn/services/store.service';
import * as moment from 'moment';

@Component({
  selector: 'app-category-other-locations',
  templateUrl: './category-other-locations.component.html',
  styleUrls: ['./category-other-locations.component.scss']
})
export class CategoryOtherLocationsComponent implements OnInit {
  conditions = Constants.HEALTH_CONDITIONS;
  category = '';

  city = '';
  post_code: '';

  nearSubHurbs: any[] = [];

  isSubCategoryPage = false;
  mainCategory = '';

  constructor(
    private route: ActivatedRoute,
    private api: ApiService,
    private store: StoreService
  ) {}

  ngOnInit(): void {
    this.route.params.subscribe((params_data: any) => {
      const params: any = { ...params_data };
      this.isSubCategoryPage = this.checkIsSubCategoryPage(params.city);
      if (this.isSubCategoryPage) {
        params.parent_category = params.category_name;
        params.category_name = params.city;
        params.city = params.post_code;
      }
      if (!this.isSubCategoryPage && params.parent_category) {
        this.isSubCategoryPage = true;
        this.mainCategory = params.parent_category;
      }

      this.category = params.category_name;

      this.city = params.city || this.store.meraLocation.city_name || 'Sydney';
      this.post_code = params.post_code || this.store.meraLocation.post_code || '2000';
      this.fetchNearSuburbs();
    });
  }

  checkIsSubCategoryPage(category: string) {
    const subCatObj = Constants.SUBCATEGORY_LIST;
    for (const key in subCatObj) {
      if (subCatObj[key].findIndex((x: any) => x.key === category) > -1) {
        this.mainCategory = key;
        return true;
      }
    }
    return false;
  }

  fetchNearSuburbs() {
    const params: any = {
      cal_date: moment().format('YYYY-MM-DD'),
      locObj: {
        city: this.city,
        post_code: this.post_code,
        state: null,
        Loclat: null,
        Loclng: null
      },
      page_size: 8,
      distance_range: 25
    };
    if (this.conditions.includes(this.category)) {
      params.symptom = this.category;
    } else {
      params.service = this.category;
    }
    this.api.getSearchResultSubUrb(params).subscribe((response) => {
      if (response.searching_city && response.searching_city.length > 0) {
        this.nearSubHurbs = [
          ...new Map(response.searching_city.map((item: any) => [item['city'], item])).values()
        ].filter((x: any) => x.city.toLowerCase().replace(/ /g, '-') !== this.city.toLowerCase());
      }
    });
  }

  fetchSubUrbURL(location: any) {
    let url =
      '/search/' +
      (this.isSubCategoryPage ? this.mainCategory + '/' : '') +
      this.category +
      '/' +
      location.city.toLowerCase().replace(/ /g, '-');

    location.postal_code = location.postal_code || location.post_code;

    if (['1000', '2000', '3000', '4000', '5000', '6000', '7000', '8000', '9000'].indexOf(location.postal_code) === -1) {
      url += '/' + location.postal_code;
    }

    return [url];
  }

  setLocation(location: any) {
    const loc = new Location();
    loc.lat = location.Loclat;
    loc.lng = location.Loclng;
    loc.post_code = location.postal_code;
    loc.city_name = location.city;
    loc.state_name = location.state;
    this.store.setmeraLocation(loc);
  }
}
